<template>
    <div>
        <div class="ix-checking-form">
            <div class="ix-checking-form-step" v-bind:class="{ active: step == 1 }">
                <div class="ix-checking-form-step-left">
                    <h2 class="ix-checking-form-step-title">1. <span class="ix-checking-form-step-name">Salariés</span></h2>

                    <div class="ix-checking-form-step-content">
                        <div v-show="step == 1">
                            <div class="ix-table-box">
                                <table class="ix-table">
                                    <tbody>
                                        <tr v-if="users.length == 0">
                                            <td colspan="100%">Aucun salarié sélectionné</td>
                                        </tr>
                                        <tr v-for="(user, index) in users" :key="index">
                                            <td>
                                                <span class="ix-avatar xsm">
                                                    <img :src="user.avatar_path" v-if="user.avatar_path">
                                                    <span v-if="!user.avatar_path">{{ user.initial }}</span>
                                                </span>
                                                {{ user.fullname }}
                                                <input type="hidden" :name="'users[' + index + '][id]'" v-model="user.id">
                                                <input type="hidden" :name="'users[' + index + '][fullname]'" v-model="user.fullname">
                                                <input type="hidden" :name="'users[' + index + '][avatar_path]'" v-model="user.avatar_path">
                                                <input type="hidden" :name="'users[' + index + '][initial]'" v-model="user.initial">
                                            </td>
                                            <td class="text-right" v-if="canSelectUsers">
                                                <button type="button" class="btn btn-sm transparent" @click="deleteUserRow(index)">
                                                    <i class="far fa-trash"></i>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr v-if="canSelectUsers">
                                            <td colspan="100%">
                                                <input placeholder="Commencer la saisie pour obtenir des suggestions .." class="form-control" id="userSearchInput" type="text" v-model="user">
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <button class="ix-btn ix-btn-small ix-btn-block blue mt-4" type="button" @click="goToStep(2)">Continuer</button>
                        </div>
                        <div v-show="step != 1">
                            <span v-if="users.length == 0">Aucun salarié sélectionné</span>
                            <div class="d-inline-block" v-for="(user, index) in users" :key="index">
                                <span class="ix-avatar xsm">
                                    <img :src="user.avatar_path" v-if="user.avatar_path">
                                    <span v-if="!user.avatar_path">{{ user.initial }}</span>
                                </span>

                                {{ user.fullname }}
                                &nbsp;
                            </div>
                        </div>
                    </div>
                </div>

                <div class="ix-checking-form-step-right"  v-if="step != 1">
                    <button class="ix-btn ix-btn-small ix-btn-icon" type="button" @click="goToStep(1)">
                        <i class="far fa-pen"></i>
                    </button>
                </div>
            </div>

            <div class="ix-checking-form-step" v-bind:class="{ active: step == 2 }">
                <div class="ix-checking-form-step-left">
                    <h2 class="ix-checking-form-step-title">2. <span class="ix-checking-form-step-name">Dates</span></h2>

                    <div class="ix-checking-form-step-content">
                        <div v-show="step == 2">
                            <div class="input-group mb-2" v-for="(date, index) in dates" :key="date.uniq">
                                <div class="ix-datepicker-wrapper">
                                    <input type="text" class="form-control checking-datepicker" placeholder="jj/mm/aaaa" :id="'datepicker' + date.uniq" v-model="date.day" name="dates[]">
                                </div>
                                <div class="input-group-append">
                                    <button class="ix-btn ix-btn-icon" type="button" @click="deleteDateRow(index)"><i class="far fa-trash"></i></button>
                                </div>
                            </div>

                            <button type="button" class="ix-btn link" @click="addDate('')"><i class="far fa-plus"></i> Ajouter une date</button>

                            <button class="ix-btn ix-btn-small ix-btn-block blue mt-4" type="button" @click="goToStep(3)">Continuer</button>
                        </div>
                        <div v-show="step != 2">
                            <span v-if="dates.length == 0">Aucune date sélectionnée</span>
                            <span v-if="dates.length > 0">
                                {{ dates.map(date => date.day).join(', ') }}
                            </span>
                        </div>
                    </div>
                </div>

                <div class="ix-checking-form-step-right" v-if="step != 2">
                    <button class="ix-btn ix-btn-small ix-btn-icon" type="button" @click="goToStep(2)">
                        <i class="far fa-pen"></i>
                    </button>
                </div>
            </div>

            <div class="ix-checking-form-step" v-bind:class="{ active: step == 3 }">
                <div class="ix-checking-form-step-left" v-if="type == 1">
                    <h2 class="ix-checking-form-step-title">3. <span class="ix-checking-form-step-name">Affaires</span></h2>
                    <div class="ix-checking-form-step-content mt-4" v-show="step == 3">
                        <div class="ix-table-box mb-3" v-show="objects.length > 0">
                            <table class="ix-table">
                                <thead>
                                    <tr>
                                        <th>Affaire</th>
                                        <th v-show="allowStartTime">Début</th>
                                        <th v-show="allowStartTime">Fin</th>
                                        <th>
                                            <div style="margin-left:70px !important">
                                                Durée 
                                                <span v-b-tooltip title="Les temps de pauses et temps de trajet ne doivent pas être comptabilisés dans ce champ">
                                                    <i class="fas fa-question-circle"></i>
                                                </span>
                                            </div>
                                        </th>
                                        <th v-show="allowNight && users && users.length > 0">Dont heures de nuit</th>
                                        <th v-show="allowRoute && users && users.length > 0">Temps de route</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-for="(object, index) in objects">
                                        <tr :key="'main-' + index">
                                            <td>
                                                <span class="ix-text-bold" v-html="truncate(object.deal_designation, 50)"></span>
                                                <input type="hidden" :name="'objects[' + index + '][deal_id]'" v-model="object.deal_id">
                                                <input type="hidden" :name="'objects[' + index + '][deal_designation]'" v-model="object.deal_designation">
                                                <div v-if="object.lot_id != null">
                                                    <input type="hidden" :name="'objects[' + index + '][lot_id]'" v-model="object.lot_id">
                                                    <input type="hidden" :name="'objects[' + index + '][lot_designation]'" v-model="object.lot_designation">
                                                    <span>{{ object.lot_designation }}</span>
                                                </div>
                                                <div v-if="object.operation_id != null">
                                                    <input type="hidden" :name="'objects[' + index + '][operation_id]'" v-model="object.operation_id">
                                                    <input type="hidden" :name="'objects[' + index + '][operation_designation]'" v-model="object.operation_designation">
                                                    <span class="ix-text-secondary">{{ object.operation_designation }}</span>
                                                </div>
                                                <div>
                                                    <button type="button" class="btn btn-sm btn-link p-0 mt-1" @click="object.show_description = !object.show_description">
                                                        <i class="far" :class="object.show_description ? 'fa-chevron-up' : 'fa-comment-alt'"></i>
                                                        {{ object.description ? 'Description ✓' : 'Ajouter une description' }}
                                                    </button>
                                                </div>

                                                <div class="form-check ix-text-red" v-show="allowBadWeather">
                                                    <input class="form-check-input" type="checkbox" value="1" :id="'is_bad_weather' + index" :name="'objects[' + index + '][is_bad_weather]'" v-model="object.is_bad_weather">
                                                    <label class="form-check-label" :for="'is_bad_weather' + index">
                                                        Intempéries
                                                    </label>
                                                </div>
                                            </td>
                                            <td v-show="allowStartTime">
                                                <input type="time" class="form-control" style="width: 110px;" v-model="object.start_time" required :name="'objects[' + index + '][start_time]'" :class="{'is-invalid': isFutureTime(object.start_time)}" @change="onStartTimeChange(object)">
                                                <div v-if="isFutureTime(object.start_time)" class="invalid-feedback d-block">
                                                    L’heure ne peut pas dépasser l’heure actuelle
                                                </div>
                                            </td>
                                            <td v-show="allowStartTime">
                                                <input type="time" class="form-control" style="width: 110px;" v-model="object.end_time" :name="'objects[' + index + '][end_time]'" :class="{'is-invalid': isFutureTime(object.end_time)}" @change="onEndTimeChange(object)">
                                                <div v-if="isFutureTime(object.end_time)" class="invalid-feedback d-block">
                                                    L’heure ne peut pas dépasser l’heure actuelle
                                                </div>
                                            </td>
                                            <td>
                                                <input type="time" class="form-control" style="width: 110px; margin-left:70px !important" v-model="object.duration" required :name="'objects[' + index + '][duration]'" @change="updateEndTimeFromDuration(object)" :class="{'checking-duration-warning': isLongDuration(object)}">
                                                <small v-if="isLongDuration(object)" class="text-warning d-block mt-1">
                                                    Pointage anormalement long  {{ formatHours(safeMaxHoursPerDay) }}
                                                </small>
                                            </td>
                                            <td v-show="allowNight && users && users.length > 0">
                                                <input type="time" class="form-control" style="width: 110px;" v-model="object.night" required :name="'objects[' + index + '][night]'" @change="validateManualNightHours(object)">
                                            </td>
                                            <td v-show="allowRoute && users && users.length > 0">
                                                <input type="time" class="form-control" style="width: 110px;" v-model="object.route" required :name="'objects[' + index + '][route]'">
                                            </td>
                                            <td class="text-right">
                                                <button type="button" class="btn btn-sm transparent" @click="deleteObjectRow(index)">
                                                    <i class="far fa-trash"></i>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr :key="'desc-' + index" v-if="object.show_description">
                                            <td :colspan="3 + (allowStartTime ? 2 : 0) + (allowNight && users && users.length > 0 ? 1 : 0) + (allowRoute && users && users.length > 0 ? 1 : 0)">
                                                <textarea 
                                                    class="form-control mt-1"
                                                    rows="20"
                                                    style="min-width: 400px; font-size: 14px; height: 70px;"
                                                    placeholder="Description / commentaire..."
                                                    v-model="object.description"
                                                    :name="'objects[' + index + '][description]'">
                                                </textarea>
                                            </td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </div>

          
                        <div v-if="totalDurationMinutes > (maxHoursPerDay || 12) * 60" class="alert alert-warning mt-2">
                            La durée cumulée des pointages dépasse {{ formatHours(safeMaxHoursPerDay) }} heures sur cette journée.
                        </div>

                        <div class="ix-simple-block">
                            <span class="ix-text-bold"></span>
                            <div class="row">
                                <div class="col-sm-12 col-md-6">
                                    <label for="dealsAutocomplete">Affaire</label>
                                    <input placeholder="Commencer la saisie pour obtenir des suggestions .." class="form-control" id="dealsAutocomplete" type="text" v-model="deal">
                                </div>

                                <div class="col-sm-12 col-md-6">
                                    <label for="lotsAutocomplete">Lot</label>
                                    <input placeholder="Commencer la saisie pour obtenir des suggestions .." class="form-control" id="lotsAutocomplete" type="text" v-model="lot">
                                    <select class="form-control mt-2" v-model="checking.operation" id="operations" :disabled="checking.operations == null" v-show="checking.operations != null">
                                        <option v-for="(item, index) in checking.operations" :key="index" :value="item">{{ item.designation }}</option>
                                    </select>
                                </div>
                            </div>

                            <div class="text-right mt-2">
                                <button class="ix-btn ix-btn-small blue" type="button" @click="addObject()" :disabled="!checking_object_is_valid">Ajouter</button>
                            </div>
                        </div>
                        <button class="ix-btn ix-btn-small ix-btn-block blue mt-4" type="button" @click="goToStep(4)">Continuer</button>
                    </div>

                     <div v-show="step != 3">
                            <span v-if="objects.length == 0">Aucune affaire sélectionnée</span>
                            <div v-if="objects.length > 0">
                                <ul class="m-0">
                                    <li v-for="(object, index) in objects" :key="index">
                                        <span class="ix-text-bold d-block">{{ object.deal_designation }}</span>
                                        <span v-if="object.lot_id">{{ object.lot_designation }}</span>
                                        <span class="ix-text-secondary" v-if="object.operation_id">({{ object.operation_designation }})</span>
                                        <span class="ix-text-secondary d-block" v-if="object.operation_id && object.station">Poste de travail : {{ object.station.name }}</span>  
                                        <ul class="m-0 pl-3" v-if="object.operation_id && object.station && object.station.equipments && object.station.equipments.length > 0">
                                            <li v-for="(eq, eqIdx) in object.station.equipments" :key="eqIdx" class="ix-text-secondary">
                                                {{ eq.name }} <small>({{ eq.hourly_rate }} €/h)</small>
                                            </li>
                                        </ul>
                                        <span class="d-block ix-text-small ix-text-secondary" v-bind:class="{'ix-text-red': object.start_time == '' || object.duration == ''}">Début : {{ object.start_time }} - Durée : {{ object.duration }} - Dont heures de nuit : {{ object.night }} - Temps de route : {{ object.route }}</span>
                                        <span v-if="object.description" class="d-block ix-text-small ix-text-secondary font-italic">
                                            <i class="far fa-comment-alt"></i> {{ object.description }}
                                        </span>
                                    </li>
                                </ul>
                            </div>
                    </div>
                </div>

                <div class="ix-checking-form-step-left" v-if="type == 2">
                    <h2 class="ix-checking-form-step-title">3. <span class="ix-checking-form-step-name">Intervention</span></h2>
                    <div class="ix-checking-form-step-content mt-4" v-show="step == 3">
                         <div class="ix-table-box mb-3" v-if="currentIntervention && currentIntervention != null">
                            <table class="ix-table">
                                <thead>
                                    <tr>
                                        <th>Intervention</th>
                                         <th v-show="allowStartTime">Début</th>
                                         <th v-show="allowStartTime">Fin</th>
                                        <th>
                                            <div style="margin-left: 70px !important;">
                                                Durée 
                                                <span v-b-tooltip title="Les temps de pauses et temps de trajet ne doivent pas être comptabilisés dans ce champ">
                                                    <i class="fas fa-question-circle"></i>
                                                </span>
                                            </div>
                                        </th>
                                        <th v-show="allowNight">Dont heures de nuit</th>
                                        <th v-show="allowRoute">Temps de route</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-for="(object, index) in objects">
                                        <tr :key="'main-' + index">
                                            <td>
                                                <span class="ix-text-bold" v-html="truncate(currentIntervention.designation, 50)"></span>
                                                <input type="hidden" :name="'objects[' + index + '][intervention_id]'" v-model="object.intervention_id">
                                                <input type="hidden" :name="'objects[' + index + '][inspection_id]'" v-model="object.inspection_id">
                                                <input type="hidden" :name="'objects[' + index + '][intervention_designation]'" v-model="object.intervention_designation">
                                                <div>
                                                    <button type="button" class="btn btn-sm btn-link p-0 mt-1" @click="object.show_description = !object.show_description">
                                                        <i class="far" :class="object.show_description ? 'fa-chevron-up' : 'fa-comment-alt'"></i>
                                                        {{ object.description ? 'Description ✓' : 'Ajouter une description' }}
                                                    </button>
                                                </div>
                                                 <div class="form-check ix-text-red" v-show="allowBadWeather">
                                                    <input class="form-check-input" type="checkbox" value="1" :id="'is_bad_weather' + index" :name="'objects[' + index + '][is_bad_weather]'" v-model="object.is_bad_weather">
                                                    <label class="form-check-label" :for="'is_bad_weather' + index">
                                                        Intempéries
                                                    </label>
                                                </div>
                                            </td>
                                            <td v-show="allowStartTime">
                                                <input type="time" class="form-control" style="width: 110px;" v-model="object.start_time" required :name="'objects[' + index + '][start_time]'" :class="{'is-invalid': isFutureTime(object.start_time)}" @change="onStartTimeChange(object)">
                                                <div v-if="isFutureTime(object.start_time)" class="invalid-feedback d-block">
                                                    L’heure ne peut pas dépasser l’heure actuelle
                                                </div>
                                            </td>
                                            <td v-show="allowStartTime">
                                                <input type="time" class="form-control" style="width: 110px;" v-model="object.end_time"  :name="'objects[' + index + '][end_time]'" :class="{'is-invalid': isFutureTime(object.end_time)}" @change="onEndTimeChange(object)">
                                                <div v-if="isFutureTime(object.end_time)" class="invalid-feedback d-block">
                                                    L’heure ne peut pas dépasser l’heure actuelle
                                                </div>
                                            </td>
                                             <td>
                                                <input type="time" class="form-control" style="width: 110px; margin-left: 70px !important;" v-model="object.duration" required :name="'objects[' + index + '][duration]'" @change="updateEndTimeFromDuration(object)" :class="{'checking-duration-warning': isLongDuration(object)}">
                                                <small v-if="isLongDuration(object)" class="text-warning d-block mt-1">
                                                    Pointage anormalement long  {{ formatHours(safeMaxHoursPerDay) }}
                                                </small>
                                            </td>
                                            <td v-show="allowNight">
                                                <input type="time" class="form-control" style="width: 110px;" v-model="object.night" required :name="'objects[' + index + '][night]'" @change="validateManualNightHours(object)">
                                            </td>
                                            <td v-show="allowRoute"> 
                                                <input type="time" class="form-control" style="width: 110px;" v-model="object.route" required :name="'objects[' + index + '][route]'">
                                            </td>
                                        </tr>
                                        <tr :key="'desc-' + index" v-if="object.show_description">
                                            <td :colspan="2 + (allowStartTime ? 2 : 0) + (allowNight ? 1 : 0) + (allowRoute ? 1 : 0)">
                                                <textarea 
                                                    class="form-control mt-1"
                                                    rows="20"
                                                    style="min-width: 400px; font-size: 14px; height: 70px;"
                                                    placeholder="Description / commentaire..."
                                                    v-model="object.description"
                                                    :name="'objects[' + index + '][description]'">
                                                </textarea>
                                            </td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                            </div>


                            <div v-if="totalDurationMinutes > (maxHoursPerDay || 12) * 60" class="alert alert-warning mt-2">
                                La durée cumulée des pointages dépasse {{ formatHours(safeMaxHoursPerDay) }} heures sur cette journée.
                            </div>
                          <div class="ix-checking-form-step-right"  v-if="step != 3">
                            <button class="ix-btn ix-btn-small ix-btn-icon" type="button" @click="goToStep(3)">
                                <i class="far fa-pen"></i>
                            </button>
                        </div>

                        <button class="ix-btn ix-btn-small ix-btn-block blue mt-4" type="button" @click="goToStep(4)">Continuer</button>
                    </div>
                      <div v-show="step != 3">
                            <span v-if="objects.length == 0">Aucune affaire sélectionnée</span>
                            <div v-if="objects.length > 0">
                                <ul class="m-0">
                                    <li v-for="(object, index) in objects" :key="index">
                                        <span class="ix-text-bold d-block">{{ object.intervention_designation }}</span>
                                        <span class="d-block ix-text-small ix-text-secondary" v-bind:class="{'ix-text-red': object.start_time == '' || object.duration == ''}">Début : {{ object.start_time }} - Durée : {{ object.duration }} - Dont heures de nuit : {{ object.night }} - Temps de route : {{ object.route }}</span>
                                        <span v-if="object.description" class="d-block ix-text-small ix-text-secondary font-italic">
                                            <i class="far fa-comment-alt"></i> {{ object.description }}
                                        </span>
                                    </li>
                                </ul>
                            </div>
                    </div>
                </div>

                <div class="ix-checking-form-step-right" v-if="step != 3">
                    <button class="ix-btn ix-btn-small ix-btn-icon" type="button" @click="goToStep(3)">
                        <i class="far fa-pen"></i>
                    </button>
                </div>
            </div>

            <div class="ix-checking-form-step" v-bind:class="{ active: step == 4}">
                <div class="ix-checking-form-step-left">
                    <h2 class="ix-checking-form-step-title">4. <span class="ix-checking-form-step-name">Matériels</span></h2>
                    <div class="ix-checking-form-step-content">
                        <div v-show="step == 4">
                            <div class="ix-table-box">
                                <table class="ix-table">
                                    <tbody>
                                        <tr v-if="equipments.length == 0">
                                            <td colspan="100%">Aucun matériel sélectionné</td>
                                        </tr>
                                        <tr v-for="(equipment, index) in equipments" :key="index">
                                            <td>
                                                {{ equipment.name }}
                                                <input type="hidden" :name="'equipments[' + index + '][id]'" v-model="equipment.id">
                                                <input type="hidden" :name="'equipments[' + index + '][name]'" v-model="equipment.name">
                                                <input type="hidden" :name="'equipments[' + index + '][hourly_rate]'" v-model="equipment.hourly_rate">
                                            </td>
                                            <td class="text-right">
                                                <button type="button" class="btn btn-sm transparent" @click="deleteEquipmentRow(index)">
                                                    <i class="far fa-trash"></i>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="100%">
                                                <input placeholder="Commencer la saisie pour obtenir des suggestions .." class="form-control" id="equipmentSearchInput" type="text" v-model="equipment">
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <button class="ix-btn ix-btn-small ix-btn-block blue mt-4" type="button" @click="goToStep(5)">Continuer</button>
                        </div>
                        <div v-show="step != 4">
                            <span v-if="equipments.length == 0">Aucun matériel sélectionné</span>
                            <span v-if="equipments.length > 0">
                                <ul class="m-0">
                                    <li v-for="(equipment, index) in equipments" :key="index">
                                        <span>{{ equipment.name }}</span>
                                    </li>
                                </ul>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="ix-checking-form-step-right" v-if="step != 4">
                    <button class="ix-btn ix-btn-small ix-btn-icon" type="button" @click="goToStep(4)">
                        <i class="far fa-pen"></i>
                    </button>
                </div>
            </div>

            <div class="ix-checking-form-step" v-bind:class="{ active: step == 5}">
                <div class="ix-checking-form-step-left">
                    <h2 class="ix-checking-form-step-title">5. <span class="ix-checking-form-step-name">Mouvements de stock</span></h2>
                    <div class="ix-checking-form-step-content">
                          <div v-show="step == 5">
                            <div class="ix-table-box mb-3" v-show="articles.length > 0">
                                    <table class="ix-table">
                                        <thead>
                                            <th>Articles</th>
                                            <th></th>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(article,index) in articles" :key="index">
                                                <td>
                                                    {{ article.name }}
                                                 
                                                    <div class="form-check" v-if="type == 1 && objects.length > 0">
                                                            <div v-for="(object,i) in objects" :key="i" class="movement-deal mb-2" style="display: flex; justify-content:space-between;">
                                                                <div class="movement-deal-designation" style="width: 200px; max-width:200px">
                                                                    {{ object.deal_designation  }}
                                                                    <small v-if="object.lot_id  && object.lot_id != null">{{ object.lot_designation }}</small>
                                                                    <input type="hidden" :name="'articles[' + index + '][' + i + '][article_id]'" v-model="article.id">
                                                                    <input type="hidden" :name="'articles[' + index + '][' + i + '][name]'" v-model="article.name">
                                                                    <span class="d-block ix-text-small ix-text-secondary" v-bind:class="{'ix-text-red': object.start_time == '' || object.duration == ''}">Début : {{ object.start_time }} - Durée : {{ object.duration }}</span>
                                                                    <input type="hidden" :name="'articles[' + index + '][' + i + '][deal_id]'" :value="object.deal_id"/>
                                                                    <input type="hidden" v-if="object.lot_id && object.lot_id != null" :name="'articles[' + index + '][' + i + '][lot_id]'" :value="object.lot_id"/>
                                                                </div>
                                                                <div class="movement-deal-quantity">
                                                                    <input type="number" class="form-control" required placeholder="Quantité" value="0" step="0.001"  style="width: 100px;" v-model="article.objects[i].quantity" :name="'articles[' + index + '][' + i + '][quantity]'"  id="quantity-checking">
                                                                </div>
                                            
                                                                <div class="movemment-deal-user" style="width: 200px">
                                                                    <select class="form-control" required :name="'articles[' + index + '][' + i + '][user_id]'" v-model="article.objects[i].user_id">
                                                                        <option v-for="(user, index) in users"  :key="index" :value="user.id" >
                                                                            {{ user.fullname }}
                                                                        </option>
                                                                    </select>
                                                                </div>
                                                                <div class="movement-deal-date_at"  style="width: 200px">
                                                                    <div class="ix-datepicker-wrapper">
                                                                        <input type="text" class="form-control checking-datepicker" required placeholder="jj/mm/aaaa" :id="'datepicker' + article.objects[i].uniq" v-model="article.objects[i].date_at" :name="'articles[' + index + '][' + i + '][date_at]'">
                                                                    </div>
                                                                </div>
                                                                <div class="movement-deal-is_out" style="max-width:300px" >
                                                                    <div class="btn-group btn-group-toggle" data-toggle="buttons">
                                                                            <label class="btn" style="border-radius: 10px;" v-bind:class="{'btn-primary active' : !article.objects[i].is_out}" @click="article.objects[i].is_out = false; article.objects[i].deal_designation = object.deal_designation">
                                                                                <input type="radio" :name="'articles[' + index + '][' + i + '][is_out]'" id="option2" value="1" v-model="article.objects[i].is_out"> 
                                                                                <span >
                                                                                    <i class="far fa-arrow-left" style="font-weight: bolder !important; font-size: 18px !important"></i>
                                                                                </span>
                                                                            </label>
                                                                             <label class="btn">
                                                                                <span class="ix-text-green"><b>E</b></span> /  <span class="ix-text-red"><b>S</b></span>
                                                                             </label>
                                                                            <label class="btn" style="border-radius: 10px;" v-bind:class="{'btn-primary active' : article.objects[i].is_out}"  @click="article.objects[i].is_out = true; article.objects[i].deal_designation = object.deal_designation">
                                                                                <input type="radio" :name="'articles[' + index + '][' + i + '][is_out]'" id="option3" value="0"  v-model="article.objects[i].is_out">  
                                                                                <span>
                                                                                    <i class="far fa-arrow-right" style="font-weight: bolder !important; font-size: 18px !important"></i>
                                                                                </span>
                                                                            </label>

                                                                        <input type="hidden" :name="'articles[' + index + '][' + i + '][is_out]'" v-model="article.objects[i].is_out ">
                                                                    </div>
                                                                </div>

                                                            </div>
                                                    </div>

                                                    <div class="form-check" v-if="type == 2 && objects.length > 0 && currentIntervention && currentIntervention != null">
                                                        <div v-for="(object,i) in objects" :key="i" class="movement-intervention mb-2" style="display: flex; justify-content:space-between;">
                                                                <div class="movement-intervention-designation" style="width: 200px; max-width:200px">
                                                                    <span v-html="truncate(currentIntervention.designation, 50)"></span>
                                                                    <input type="hidden" :name="'articles[' + index + '][' + i + '][article_id]'" v-model="article.id">
                                                                    <input type="hidden" :name="'articles[' + index + '][' + i + '][name]'" v-model="article.name">
                                                                    <span class="d-block ix-text-small ix-text-secondary" v-bind:class="{'ix-text-red': object.start_time == '' || object.duration == ''}">Début : {{ object.start_time }} - Durée : {{ object.duration }}</span>
                                                                    <input type="hidden" :name="'articles[' + index + '][' + i + '][intervention_id]'" :value="object.intervention_id"/>
                                                                </div>
                                                                  <div class="movement-deal-quantity">
                                                                    <input type="number" step="0.001" class="form-control" required placeholder="Quantité" value="0"  style="width: 100px;" v-model="article.objects[i].quantity" :name="'articles[' + index + '][' + i + '][quantity]'" >
                                                                </div>
                                                                <div class="movemment-deal-user" style="width: 200px">
                                                                    <select class="form-control" required :name="'articles[' + index + '][' + i + '][user_id]'" v-model="article.objects[i].user_id">
                                                                        <option v-for="(user, index) in users"  :key="index" :value="user.id" >
                                                                            {{ user.fullname }}
                                                                        </option>
                                                                    </select>
                                                                </div>
                                                                <div class="movement-deal-date_at"  style="width: 200px">
                                                                    <div class="ix-datepicker-wrapper">
                                                                        <input type="text" class="form-control checking-datepicker" required placeholder="jj/mm/aaaa" :id="'datepicker' + article.objects[i].uniq" v-model="article.objects[i].date_at" :name="'articles[' + index + '][' + i + '][date_at]'">
                                                                    </div>
                                                                </div>
                                                              
                                                                <div class="movement-deal-is_out" style="max-width:300px">
                                                                    <div class="btn-group btn-group-toggle" data-toggle="buttons">
                                                                            <label class="btn" style="border-radius: 10px" v-bind:class="{'btn-primary active' : !article.objects[i].is_out}" @click="article.objects[i].is_out = false">
                                                                                <input type="radio" :name="'articles[' + index + '][' + i + '][is_out]'" id="option2" value="1" v-model="article.objects[i].is_out"> 
                                                                                 <span>
                                                                                     <i class="far fa-arrow-left" style="font-weight: bolder !important; font-size: 18px !important"></i>
                                                                                 </span>
                                                                            </label>
                                                                             <label class="btn">
                                                                               <span class="ix-text-green"><b>E</b></span> /  <span class="ix-text-red"><b>S</b></span>
                                                                             </label>
                                                                            <label class="btn" style="border-radius: 10px" v-bind:class="{'btn-primary active' : article.objects[i].is_out}"  @click="article.objects[i].is_out = true">
                                                                                <input type="radio" :name="'articles[' + index + '][' + i + '][is_out]'" id="option3" value="0"  v-model="article.objects[i].is_out"> 
                                                                                <span> 
                                                                                    <i class="far fa-arrow-right" style="font-weight: bolder !important; font-size: 18px !important"></i>
                                                                                    </span>
                                                                            </label>

                                                                        <input type="hidden" :name="'articles[' + index + '][' + i + '][is_out]'" v-model="article.objects[i].is_out ">
                                                                    </div>
                                                                </div>

                                                            </div>
                                                    </div>
                                                </td>
                                                <td class="text-right">
                                                    <button type="button" class="btn btn-sm transparent" @click="deleteArticleRow(index)">
                                                        <i class="far fa-trash"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            <div class="row mt-4">
                                <div class="col-sm-12 text-left">
                                    <input placeholder="Commencer la saisie pour obtenir des suggestions .." class="form-control" id="articleSearchInput" type="text" v-model="article">
                                </div>
                            </div>
                           

                            <button class="ix-btn ix-btn-small ix-btn-block blue mt-4" type="button" @click="goToStep(6)">Continuer</button>
                        </div>
                    </div>
                      
                        <div v-show="step != 5">
                            <span v-if="articles.length == 0">Aucun article sélectionné</span>
                            <div class="d-inline-block">
                                <ul class="m-0">
                                    <li v-for="(article, index) in articles" :key="index">
                                        <span class="ix-text-bold ">{{ article.name  }}</span>
                                        <span class="ix-text-secondary" v-for="(object, i) in article.objects" :key="i">
                                            <span class="d-block">
                                                <span  v-if="type == 2">
                                                    <b class="ix-text-red" v-if="object.is_out">S - </b>
                                                    <b class="ix-text-green" v-if="!object.is_out">E -</b>
                                                    {{ currentIntervention.designation  }}
                                                    </span>
                                               
                                                <span  v-if="type == 1 && object.quantity != 0">
                                                    <b class="ix-text-red" v-if="object.is_out">S - </b>
                                                    <b class="ix-text-green" v-if="!object.is_out">E - </b>
                                                    {{ object.deal_designation }}
                                                </span>
                                                <b v-if="object.quantity != 0">({{ object.quantity }}) :</b>   
                                                <span  v-if="object.user_id && object.user_id != null &&  object.quantity != 0">{{ getUserMovementSelected(object.user_id) }} </span>
                                                <span v-if="object.date_at && object.date_at && object.quantity != 0"> le : {{ object.date_at }}</span>
                                            </span>
                                           
                                        </span>
                                       
                                    </li>
                                </ul>
                                &nbsp;
                            </div>
                        </div>


                </div>
                <div class="ix-checking-form-step-right"  v-if="step != 5">
                    <button class="ix-btn ix-btn-small ix-btn-icon" type="button" @click="goToStep(5)">
                        <i class="far fa-pen"></i>
                    </button>
                </div>
            </div>
           


            <div class="ix-checking-form-step" v-bind:class="{ active: step == 6 }" v-show="users && users.length > 0">
                <div class="ix-checking-form-step-left">
                    <h2 class="ix-checking-form-step-title">6. <span class="ix-checking-form-step-name">Primes</span></h2>

                    <div class="ix-checking-form-step-content">
                        <div v-show="step == 6">
                            <div class="ix-table-box">
                                <table class="ix-table">
                                    <tbody>
                                        <tr v-if="bonuses.length == 0">
                                            <td colspan="100%">Aucune prime sélectionnée</td>
                                        </tr>
                                        <tr v-for="(bonus, index) in bonuses" :key="index">
                                            <td>
                                                <b class="mb-2">{{ bonus.designation }}</b>
                                                <div class="form-check" v-if="objects.length > 0">
                                                        <div v-for="(object,i) in objects" :key="i" class="movement-deal mb-2" style="display: flex; justify-content:space-between;">
                                                            <div class="bounty-deal-designation" style="width: 200px; max-width:200px">
                                                                <span v-if="type == 1 ">{{ object.deal_designation  }}</span>
                                                                <span  v-if="type == 2" v-html="truncate(currentIntervention.designation, 50)" ></span>
                                                                <small v-if="object.lot_id  && object.lot_id != null && type == 1">{{ object.lot_designation }}</small>
                                                                <input type="hidden" :name="'bonuses[' + index + ']['+ i +'][id]'" v-model="bonus.id">
                                                                <input type="hidden" :name="'bonuses[' + index + ']['+ i +'][designation]'" v-model="bonus.designation">
                                                                <input type="hidden" :name="'bonuses[' + index + ']['+ i +'][type]'" v-model="bonus.type">
                                                                <input v-if="type == 1 " type="hidden" :name="'bonuses[' + index + ']['+ i +'][deal_id]'" :value="object.deal_id"/>
                                                                <input type="hidden" v-if="object.lot_id && object.lot_id != null && type == 1" :name="'bonuses[' + index + '][' + i + '][lot_id]'" :value="object.lot_id"/> 
                                                                <input v-if="type == 2" type="hidden" :name="'bonuses[' + index + '][' + i + '][intervention_id]'" :value="object.intervention_id"/>
                                                            </div>
                                                            <div class="bounty-quantity">
                                                                <div class="input-group mt-2"  v-show="bonus.type == 2 || bonus.type == 3">
                                                                    <input :type="bonus.type == 2 ? 'time' : 'number'" :name="'bonuses[' + index + ']['+ i +'][details]'" class="form-control form-control-sm" v-model="bonus.objects[i].details" :required="bonus.type == 2 || bonus.type == 3">
                                                                    <div class="input-group-append" v-if="bonus.type == 3">
                                                                        <span class="input-group-text">km</span>
                                                                    </div>
                                                                </div>
                                                                <input type="hidden" value="1" v-if="objects.length == 1" :name="'bonuses[' + index + ']['+ i +'][checked]'"  />
                                                                <input type="checkbox" class="form-control" v-if="bonus.type == 1 && objects.length > 1" :name="'bonuses[' + index + ']['+ i +'][checked]'" v-model="bonus.objects[i].checked" @change="updateBonusObject(i,bonus,object)"/>
                                                            </div>
                                                        </div>
                                                    </div>
                                            </td>
                                            <td class="text-right">
                                                <button type="button" class="btn btn-sm transparent" @click="deleteBonusRow(index)">
                                                    <i class="far fa-trash"></i>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="100%">
                                                <input placeholder="Commencer la saisie pour obtenir des suggestions .." class="form-control" id="bonusSearchInput" type="text" v-model="bonus" >
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <button class="ix-btn ix-btn-small ix-btn-block blue mt-4" type="button" @click="goToStep(7)">Continuer</button>
                        </div>
                        <div v-show="step != 6">
                            <span v-if="bonuses.length == 0">Aucune prime sélectionnée</span>
                            <span v-if="bonuses.length > 0">
                                <ul class="m-0">
                                    <li v-for="(bonus, index) in bonuses" :key="index">
                                        <span>
                                            {{ bonus.designation }} 
                                            
                                        </span>
                                       
                                        <span class="d-block ix-text-red" v-if="type == 1 && objects.length > 1 && countBonusObject(bonus) == 0">Aucune affaire sélectionnée</span>
                                        <div v-for="(object, i) in bonus.objects" :key="i">
                                            <span class="d-block" v-if="type == 1 && object.object"><b>{{ object.object.deal_designation }}</b></span>
                                        </div>
                                    </li>
                                </ul>
                            </span>
                        </div>
                    </div>
                </div>

                <div class="ix-checking-form-step-right" v-if="step != 6">
                    <button class="ix-btn ix-btn-small ix-btn-icon" type="button" @click="goToStep(6)">
                        <i class="far fa-pen"></i>
                    </button>
                </div>
            </div>

         <!-- <div class="ix-checking-form-step" v-bind:class="{ active: step == 7 }">
                <div class="ix-checking-form-step-left">
                    <h2 class="ix-checking-form-step-title">7. <span class="ix-checking-form-step-name">Informations additionnelles</span></h2>

                    <div class="ix-checking-form-step-content">
                        <div v-show="step == 7">
                            <textarea name="description" rows="3" class="form-control" v-model="description"></textarea>
                        </div>
                        <div v-show="step != 7">
                            <p v-html="nl2br(description ? description : '-')"></p>
                        </div>
                    </div>
                </div>

                <div class="ix-checking-form-step-right" v-if="step != 7">
                    <button class="ix-btn ix-btn-small ix-btn-icon" type="button" @click="goToStep(7)">
                        <i class="far fa-pen"></i>
                    </button>
                </div>
            </div>-->  

            <div class="form-check mt-4" v-if="canValid">
                <input type="checkbox" v-model="validate" name="validate" value="1" id="validate">
                <label class="form-check-label" for="validate">
                    Validation automatique
                    <span class="ix-text-small ix-text-secondary">(Les pointages générés ne seront pas modifiables)</span><br>
                </label>
            </div>

            <div class="form-check mt-1" v-if="!canValidMovement && canValid">
                <span class="ix-text-small ix-text-orange" ><i class="fas fa-exclamation-triangle"></i> Les mouvements de stocks ne seront pas validés</span>
            </div>
        </div>

        <div class="ix-form-actions mt-4">
            <div class="ix-form-actions-left">
                <a :href="checkingsArrayRoute" class="ix-btn transparent">Retourner sur le tableau</a>
            </div>
            <div class="ix-form-actions-right">
                <button class="ix-btn green" type="submit" :disabled="isFormValid() == false">Enregistrer</button>
            </div>
        </div>
    </div>
</template>

<script>

    const TYPE_CHECKING_HR = 1;
    const TYPE_CHECKING_GMAO = 2;
    
    export default {
        name: 'checking-form',
        props: ['usersRoute', 'bonusesRoute', 'dealsRoute', 'equipmentsRoute', 'articlesRoute' ,'oldData', 'initialData', 'checkingsArrayRoute', 'dateStart', 'dateEnd', 'canValid','canValidMovement', 'canSelectUsers', 'allowStartTime', 'allowNight', 'nightStart', 'nightEnd', 'allowRoute', 'lotsRoute','canSelectAllUsers','typeChecking','intervention', 'canAllowBadWeather', 'maxHoursPerDay', 'minNightHoursPerDay', 'allowFutureDate'],
        data() { 
            return {
                step: 1,
                dates: [],
                objects: [],
                bonuses: [],
                users: [],
                equipments: [],
                articles: [],
                description: '',
                validate: this.canValid ? 1 : 0,
                bonus: null,
                user: null,
                deal: null,
                lot: null,
                equipment: null,
                article: null,
                checking: {
                    deal: null,
                    lot: null,
                    operations: null,
                    operation: null,
                    intervention: null,
                    equipments: null,
                    movements: null,
                },
                type: this.typeChecking ? this.typeChecking : TYPE_CHECKING_HR,
                currentIntervention: null,
                allowBadWeather: this.canAllowBadWeather ? this.canAllowBadWeather : false,
            };
        },
        computed: {
            checking_object_is_valid: function(){
                return this.checking.deal != null && this.checking.deal.id != null && this.checking.deal.id != ''
            },
            totalDurationMinutes(){
                let total = 0;

                this.objects.forEach((object) => {
                    if (!object.duration) {
                        return;
                    }

                    const parts = object.duration.split(':');
                    if (parts.length !== 2) {
                        return;
                    }

                    const h = parseInt(parts[0], 10);
                    const m = parseInt(parts[1], 10);
                    if (isNaN(h) || isNaN(m)) {
                        return;
                    }

                    total += h * 60 + m;
                });

                return total;
            },
             safeMaxHoursPerDay() {
                return this.maxHoursPerDay || 12
            }
        },
        methods : {
            nextStep: function() {
                this.step ++
            },
            goToStep: function(step) {
                if (this.step == 2) {
                    this.dates = this.dates.filter(date => { return date.day != null && date.day != '' })
                }

                this.step = step
            },
            updateBonusObject(index , bonus , object){
                if(bonus.objects[index].checked){
                    bonus.objects[index].object = object;
                } else {
                    bonus.objects[index].object = null;
                }
            },
            countBonusObject(bonus){
                return bonus.objects.filter(object => {return object.object  != null }).length
            },
            getUserMovementSelected(userId){
                return this.users.filter(user => { return user.id == userId})[0].fullname
            },
            // Dates
            getCurrentSelectedDates: function() {
                return this.dates.map((date) => {return date.day });
            },
            setDisabledDates: function() {
                var dates = this.getCurrentSelectedDates()
                
                this.dates.forEach((date) => {
                    $('#datepicker' + date.uniq).datepicker('setDatesDisabled', dates)
                })
            },
            addDate: function(date) {
                var uniq = Math.random().toString(36).substr(2, 9)
                var currentSelectedDates = this.getCurrentSelectedDates()

                this.dates.push({
                    uniq: uniq,
                    day: date
                })
                
                setTimeout(() => {
                    $("#datepicker" + uniq).datepicker({
                        format: "dd/mm/yyyy",
                        todayBtn: true,
                        language: "fr",
                        calendarWeeks: true,
                        autoclose: true,
                        todayHighlight: true,
                        clearBtn: false,
                        startDate: this.dateStart,
                        endDate: (this.allowFutureDate === true || this.allowFutureDate === 'true' || this.allowFutureDate === '1' || this.allowFutureDate === 1) ? this.dateEnd : (this.dateEnd || new Date()),
                        datesDisabled: currentSelectedDates
                    }).on('changeDate', function(e) {
                        // TODO : Fix datesDisabled
                    });

                    $("#datepicker" + uniq).change(function() {
                        $(this)[0].dispatchEvent(new Event('input'));
                    });
                }, 250)
            },
            deleteDateRow: function (index) {
                this.dates.splice(index, 1)

                this.setDisabledDates()
            },
            // Objects
            addObject: function(object = null, movement = null) {

                if(this.type == TYPE_CHECKING_HR){
                    if(object != null){
                        this.objects.push({
                            is_bad_weather: object.is_bad_weather,
                            deal_id: object.deal_id,
                            deal_designation: object.deal_designation,
                            start_time: object.start_time ? object.start_time : (this.allowStartTime ? '' : '00:00'),
                            end_time: object.end_time ? object.end_time : (this.allowStartTime ? '' : '00:00'),
                            duration: object.duration ? object.duration : '',
                            route: object.route ? object.route : '00:00',
                            night: object.night ? object.night : '00:00',
                            lot_id: object.lot_id ? object.lot_id : null,
                            lot_designation: object.lot_designation ? object.lot_designation : null,
                            operation_id: object.operation_id ? object.operation_id : null,
                            operation_designation: object.operation_designation ? object.operation_designation : null,
                            quantity: object.quantity ? object.quantity : 0,
                            is_out: object.is_out ? object.is_out : true,
                            station : object.station ? object.station : null,
                            show_description: false,
                            description: object.description ? object.description : ''
                        })
                    } else {
                        this.objects.push({
                            is_bad_weather: this.checking.deal.is_bad_weather,
                            deal_id: this.checking.deal.id,
                            deal_designation: this.checking.deal.designation,
                            start_time: this.checking.deal.start_time ? this.checking.deal.start_time : (this.allowStartTime ? '' : '00:00'),
                            end_time: this.checking.deal.end_time ? this.checking.deal.end_time : (this.allowStartTime ? '' : '00:00'),
                            duration: this.checking.deal.duration ? this.checking.deal.duration : '',
                            route: this.checking.deal.route ? this.checking.deal.route : '00:00',
                            night: this.checking.deal.night ? this.checking.deal.night : '00:00',
                            lot_id: this.checking.lot ? this.checking.lot.id : null,
                            lot_designation: this.checking.lot ? this.checking.lot.designation : null,
                            operation_id: this.checking.lot ? (this.checking.operation ? this.checking.operation.id : null) : null,
                            operation_designation: this.checking.lot ? (this.checking.operation ? this.checking.operation.designation : null) : null,
                            quantity: 0,
                            is_out: true,
                            station: this.checking.lot && this.checking.operation ? this.checking.operation.station : null,
                            show_description: false,
                            description: ''
                           
                        });
                    }   
                }

                if(this.type == TYPE_CHECKING_GMAO){
                    if(object != null){
                        this.objects.push({
                            is_bad_weather: object.is_bad_weather,
                            intervention_id: object.intervention_id,
                            inspection_id: object.inspection_id,
                            intervention_designation: object.intervention_designation,
                            start_time: object.start_time ? object.start_time : (this.allowStartTime ? '' : '00:00'),
                            end_time: object.end_time ? object.end_time : (this.allowStartTime ? '' : '00:00'),
                            duration: object.duration ? object.duration : '',
                            route: object.route ? object.route : '00:00',
                            night: object.night ? object.night : '00:00',
                            show_description: false,
                            description: object.description ? object.description : ''
                        })
                    } else {
                        this.objects.push({
                            is_bad_weather: false,
                            intervention_id: this.currentIntervention.id,
                            inspection_id: this.currentIntervention.inspection_id,
                            intervention_designation: this.currentIntervention.designation,
                            start_time: this.checking.intervention != null && this.checking.intervention.start_time ? this.checking.intervention.start_time : (this.allowStartTime ? '' : '00:00'),
                            end_time: this.checking.intervention != null && this.checking.intervention.end_time ? this.checking.intervention.end_time : (this.allowStartTime ? '' : '00:00'),
                            duration: this.checking.intervention != null && this.checking.intervention.duration ? this.checking.intervention.duration : '',
                            route:  this.checking.intervention != null && this.checking.intervention.route ? this.checking.intervention.route : '00:00',
                            night: this.checking.intervention != null && this.checking.intervention.night ? this.checking.intervention.night : '00:00',
                            show_description: false,
                            description: ''
                        });
                    }
                }

                if(this.articles && this.articles.length){
                    this.articles.forEach((article) => {

                        var uniq = Math.random().toString(36).substr(2, 9);
                        article.objects.push({
                            quantity : 0,
                            is_out: true,
                            uniq : Math.random().toString(36).substr(2, 9),
                            user_id :  this.users && this.users.length ? this.users[0].id : null,
                            date_at :  this.dates && this.dates.length ? this.dates[0].day : this.moment().format('DD/MM/YYYY'),
                            deal_designation :  this.type == 1 ? this.checking.deal.designation : null,
                            uniq : uniq
                        });

                        setTimeout(() => {
                            $("#datepicker" + uniq).datepicker({
                                format: "dd/mm/yyyy",
                                todayBtn: true,
                                language: "fr",
                                calendarWeeks: true,
                                autoclose: true,
                                todayHighlight: true,
                                clearBtn: false,
                            }).on('changeDate', function(e) {
                                // TODO : Fix datesDisabled
                            });

                            $("#datepicker" + uniq).change(function() {
                                $(this)[0].dispatchEvent(new Event('input'));
                            });
                        }, 250)
                    })
                }

                if(this.bonuses && this.bonuses.length){
                    this.bonuses.forEach((bonus) => {
                        bonus.objects.push({
                            details : bonus.type == 2 ? '00:00' : 0,
                            checked: false,
                            object: null,
                        })
                    })
                }
                

                this.deal = null;
                this.lot = null;
                this.operation = null;
                this.checking.deal = null;
                this.checking.lot = null;
                this.checking.operations = null;
                this.checking.operation = null;
                this.checking.intervention = null;
        
                console.log(object, this.objects, this.checking)
            },
            deleteObjectRow: function (index) {
                this.objects.splice(index, 1)
            },
            // Bonuses
            addBonusRow: function (bonus) {
                bonus.objects = [];
                this.objects.forEach((object) => {
                    bonus.objects.push({
                        details: bonus.type == 2 ? '00:00' : 0,
                        checked: false,    
                        object: null,
                    });
                })

                if (this.getCurrentSelectedBonusesId().includes(bonus.id) == false) {
                    this.bonuses.push({
                        id: bonus.id,
                        type: bonus.type,
                        designation: bonus.designation,
                        details: bonus.details,
                        objects: bonus.objects
                    })
                }
            },
            deleteBonusRow: function (index) {
                this.bonuses.splice(index, 1)
            },
            getCurrentSelectedBonusesId: function() {
                return this.bonuses.map(bonus => bonus.id);
            },
            // Users
            addUserRow: function (user) {
                if (this.getCurrentSelectedUsersId().includes(user.id) == false) {
                    this.users.push(user)
                }
            },
            deleteUserRow: function (index) {
                this.users.splice(index, 1)
            },
            getCurrentSelectedUsersId: function() {
                return this.users.map(user => user.id);
            },
            // Equipments
            getCurrentSelectedEquipmentId: function() {
                return this.equipments.map(equipment => equipment.id);
            },
            addEquipmentRow: function(equipment){
                if(this.getCurrentSelectedEquipmentId().includes(equipment.id) == false){
                    this.equipments.push(equipment);
                }
            },
            deleteEquipmentRow: function(index){
                this.equipments.splice(index, 1);
            },
            addArticleRow: function(article){
                article.objects =[]
                this.objects.forEach((object) => {
                    var uniq = Math.random().toString(36).substr(2, 9);
                    article.objects.push({
                        quantity: article && article.quantity ? article.quantity : 0,
                        is_out: true,
                        user_id :  this.users && this.users.length ? this.users[0].id : null,
                        date_at :  this.dates && this.dates.length ? this.dates[0].day : this.moment().format('DD/MM/YYYY'),
                        uniq : uniq,
                        deal_designation : this.type == 1 ? object.deal_designation : null,
                    });

                     setTimeout(() => {
                        $("#datepicker" + uniq).datepicker({
                            format: "dd/mm/yyyy",
                            todayBtn: true,
                            language: "fr",
                            calendarWeeks: true,
                            autoclose: true,
                            todayHighlight: true,
                            clearBtn: false,
                        }).on('changeDate', function(e) {
                            // TODO : Fix datesDisabled
                        });

                        $("#datepicker" + uniq).change(function() {
                            $(this)[0].dispatchEvent(new Event('input'));
                        });
                    }, 250)
                })

                if(this.getCurrentSelectedArticlesId().includes(article.id) == false){
                    this.articles.push(article);
                }

            },
            deleteArticleRow: function(index){
                this.articles.splice(index, 1);
            },
            isFutureTime: function(timeStr) {
                // Si l'on autorise le pointage dans le futur, on ne bloque jamais sur l'heure
                if (this.allowFutureDate === true || this.allowFutureDate === 'true' || this.allowFutureDate === '1' || this.allowFutureDate === 1) {
                    return false;
                }

                if (!timeStr) {
                    return false;
                }

                const hasToday = this.dates.some(date => {
                    if (!date.day) return false;
                    const parts = date.day.split('/');
                    if (parts.length !== 3) return false;
                    const d = parseInt(parts[0], 10);
                    const m = parseInt(parts[1], 10) - 1;
                    const y = parseInt(parts[2], 10);
                    const checkingDate = new Date(y, m, d);
                    const today = new Date();
                    return checkingDate.getFullYear() === today.getFullYear() &&
                           checkingDate.getMonth() === today.getMonth() &&
                           checkingDate.getDate() === today.getDate();
                });

                if (!hasToday) {
                    return false;
                }

                const parts = timeStr.split(':');
                if (parts.length !== 2) {
                    return false;
                }

                const h = parseInt(parts[0], 10);
                const m = parseInt(parts[1], 10);
                if (isNaN(h) || isNaN(m)) {
                    return false;
                }

                const today = new Date();
                const currentH = today.getHours();
                const currentM = today.getMinutes();

                if (h > currentH) {
                    return true;
                } else if (h === currentH && m > currentM) {
                    return true;
                }

                return false;
            },
            onStartTimeChange: function(object) {
                if (object.end_time) {
                    this.updateDurationFromEndTime(object);
                }
            },
            onEndTimeChange: function(object) {
                this.updateDurationFromEndTime(object);
            },
            updateDurationFromEndTime: function(object) {
                if (!object || !object.start_time || !object.end_time) {
                    return;
                }

                const parseTime = (timeStr) => {
                    const parts = timeStr.split(':');
                    if (parts.length !== 2) {
                        return null;
                    }
                    const h = parseInt(parts[0], 10);
                    const m = parseInt(parts[1], 10);
                    if (isNaN(h) || isNaN(m)) {
                        return null;
                    }
                    return h * 60 + m;
                };

                const startMinutes = parseTime(object.start_time);
                const endMinutes = parseTime(object.end_time);

                if (startMinutes === null || endMinutes === null) {
                    return;
                }

                let diff = endMinutes - startMinutes;

                // Si l'heure de fin est avant le début, on considère que c'est le lendemain
                if (diff < 0) {
                    diff += 24 * 60; // Ajouter 24h en minutes
                }

                if (diff === 0) {
                    return;
                }

                const hours = Math.floor(diff / 60);
                const minutes = diff % 60;

                const pad = (n) => (n < 10 ? '0' + n : '' + n);
                object.duration = pad(hours) + ':' + pad(minutes);
                this.calculateNightHours(object);
            },
            updateEndTimeFromDuration: function(object) {
                if (!object || !object.start_time || !object.duration) {
                    return;
                }

                const parseTime = (timeStr) => {
                    const parts = timeStr.split(':');
                    if (parts.length !== 2) {
                        return null;
                    }
                    const h = parseInt(parts[0], 10);
                    const m = parseInt(parts[1], 10);
                    if (isNaN(h) || isNaN(m)) {
                        return null;
                    }
                    return h * 60 + m;
                };

                const startMinutes = parseTime(object.start_time);
                const durationMinutes = parseTime(object.duration);

                if (startMinutes === null || durationMinutes === null) {
                    return;
                }

                let endMinutes = startMinutes + durationMinutes;

                // On borne dans la journée (optionnel) : 0..1439
                if (endMinutes < 0) {
                    endMinutes = 0;
                }

                const hours = Math.floor(endMinutes / 60) % 24;
                const minutes = endMinutes % 60;

                const pad = (n) => (n < 10 ? '0' + n : '' + n);
                object.end_time = pad(hours) + ':' + pad(minutes);
                this.calculateNightHours(object);
            },
            calculateNightHours: function(object) {
                if (!object || !object.start_time || !object.duration) {
                    return;
                }

                if (!this.allowNight) {
                    object.night = '00:00';
                    return;
                }

                const parseTime = (timeStr) => {
                    const parts = timeStr.split(':');
                    if (parts.length !== 2) return null;
                    const h = parseInt(parts[0], 10);
                    const m = parseInt(parts[1], 10);
                    if (isNaN(h) || isNaN(m)) return null;
                    return h * 60 + m;
                };

                const startMinutes = parseTime(object.start_time);
                const durationMinutes = parseTime(object.duration);
                if (startMinutes === null || durationMinutes === null) return;

                // Horaires de nuit depuis les paramètres (format: nombre d'heures ex: 21, 6)
                const nightStartHour = parseInt(this.nightStart, 10) || 21;
                const nightEndHour = parseInt(this.nightEnd, 10) || 6;
                const minNightHoursPerDay = parseFloat(this.minNightHoursPerDay) || 1;
           
                const minNightMinutesPerDay = minNightHoursPerDay * 60;
                const nightStartMinutes = nightStartHour * 60;
                const nightEndMinutes = nightEndHour * 60;

                let nightMinutes = 0;
                const endMinutes = startMinutes + durationMinutes;

                for (let t = startMinutes; t < endMinutes; t++) {
                    const timeInDay = t % (24 * 60);
                    // Nuit : gère le cas où les horaires chevauchent minuit (ex: 21h-06h)
                    const isNight = (nightStartMinutes > nightEndMinutes)
                        ? (timeInDay >= nightStartMinutes || timeInDay < nightEndMinutes)
                        : (timeInDay >= nightStartMinutes && timeInDay < nightEndMinutes);
                    if (isNight) {
                        nightMinutes++;
                    }
                }

                // Ne comptabiliser les heures de nuit que si le minimum est atteint
                let finalNightMinutes = 0;
                if (nightMinutes >= minNightMinutesPerDay) {
                    finalNightMinutes = nightMinutes;
                }

                const hours = Math.floor(finalNightMinutes / 60);
                const minutes = finalNightMinutes % 60;
                const pad = (n) => (n < 10 ? '0' + n : '' + n);
                object.night = pad(hours) + ':' + pad(minutes);
            },
            validateManualNightHours: function(object) {
                if (!object || !object.night || !object.start_time || !object.duration) {
                    return;
                }

                const parseTime = (timeStr) => {
                    const parts = timeStr.split(':');
                    if (parts.length !== 2) return null;
                    const h = parseInt(parts[0], 10);
                    const m = parseInt(parts[1], 10);
                    if (isNaN(h) || isNaN(m)) return null;
                    return h * 60 + m;
                };

                const startMinutes = parseTime(object.start_time);
                const durationMinutes = parseTime(object.duration);
                const nightMinutesEntered = parseTime(object.night);
                
                if (startMinutes === null || durationMinutes === null || nightMinutesEntered === null) {
                    return;
                }

                // Calculer les heures de nuit réelles sur la plage horaire
                const nightStartHour = parseInt(this.nightStart, 10) || 21;
                const nightEndHour = parseInt(this.nightEnd, 10) || 6;
                const nightStartMinutes = nightStartHour * 60;
                const nightEndMinutes = nightEndHour * 60;

                let actualNightMinutes = 0;
                const endMinutes = startMinutes + durationMinutes;

                for (let t = startMinutes; t < endMinutes; t++) {
                    const timeInDay = t % (24 * 60);
                    const isNight = (nightStartMinutes > nightEndMinutes)
                        ? (timeInDay >= nightStartMinutes || timeInDay < nightEndMinutes)
                        : (timeInDay >= nightStartMinutes && timeInDay < nightEndMinutes);
                    if (isNight) {
                        actualNightMinutes++;
                    }
                }

                const minNightHoursPerDay = parseFloat(this.minNightHoursPerDay) || 1;
                const minNightMinutesPerDay = minNightHoursPerDay * 60;

                // Appliquer la règle du minimum
                const pad = (n) => (n < 10 ? '0' + n : '' + n);
                
                if (actualNightMinutes < minNightMinutesPerDay) {
                    // Si le temps réel sur la plage de nuit est inférieur au minimum, on met à 00:00
                    object.night = '00:00';
                } else {
                    // Si le temps réel est >= minimum, on limite la saisie au temps réel calculé
                    if (nightMinutesEntered > actualNightMinutes) {
                        const hours = Math.floor(actualNightMinutes / 60);
                        const minutes = actualNightMinutes % 60;
                        object.night = pad(hours) + ':' + pad(minutes);
                    }
                }
            },
            isLongDuration: function(object) {
                if (!object || !object.duration) {
                    return false;
                }

                const parts = object.duration.split(':');
                if (parts.length !== 2) {
                    return false;
                }

                const h = parseInt(parts[0], 10);
                const m = parseInt(parts[1], 10);
                if (isNaN(h) || isNaN(m)) {
                    return false;
                }

                const totalMinutes = h * 60 + m;
                const maxMinutes = (this.maxHoursPerDay || 12) * 60;
                return totalMinutes > maxMinutes;
            },
            // Articles
            getCurrentSelectedArticlesId: function(){
                return this.articles.map(article => article.id);
            },
            // Validation
            isFormValid: function (){
                return  (this.users.length > 0 || this.equipments.length > 0) && this.validateStep(4) && this.validateStep(5) && this.validateStep(6);
            },
            validateStep: function (step) {
                if (step == 1) {
                    //return this.users.length > 0;
                } else if (step == 4) {
                    var countErrorsInDates = this.dates.filter(date => { return date.day == null || date.day == '' }).length

                    return this.dates.length > 0 && countErrorsInDates == 0;
                } else if (step == 5) {
                    if(this.type == TYPE_CHECKING_HR){
                        var countErrorsInObjects = this.objects.filter(object => { 
                        return object.deal_id == null ||
                            object.deal_id == '' ||
                            object.start_time == '' ||
                            object.duration == '' ||
                            object.night == '' ||
                            object.hours == '' ||
                            this.isFutureTime(object.start_time) ||
                            this.isFutureTime(object.end_time)
                        }).length
                    }

                    if(this.type == TYPE_CHECKING_GMAO){
                        var countErrorsInObjects = this.objects.filter(object => { 
                        return object.intervention_id == null ||
                            object.intervention_id == '' ||
                            object.start_time == '' ||
                            object.duration == '' ||
                            object.night == '' ||
                            object.hours == '' ||
                            this.isFutureTime(object.start_time) ||
                            this.isFutureTime(object.end_time)
                        }).length
                    }
                    

                    return this.objects.length > 0 && countErrorsInObjects == 0;
                } 

                return true;
            }
        },
        mounted(){
            $("#bonusSearchInput").autocomplete({
                minLength: 0,
                source: (request, response) => {
                    $.ajax({
                        url : this.bonusesRoute,
                        type: 'get',
                        dataType : 'json',
                        headers: this.getHttpJsonRequestHeaders().headers,
                        data: { q: request.term, '!id': this.getCurrentSelectedBonusesId().join(';')},
                        success: (data) => {
                            response($.map(data, (item) => {
                                return Object.assign(item, {
                                    label: item.designation,
                                    value: item.designation
                                })
                            }))
                        }
                    });
                },
                create: function () {
                    $(this).data('ui-autocomplete')._renderItem = function (ul, item) {
                        var subcontent = item.conditions ? `<span class="ui-autocomplete-subcontent">(${item.conditions})</span>` : ''

                        var html = `<div class="d-flex align-items-center">
                                      <span>${item.designation} ${subcontent}</span>
                                    </div>`;

                        if (item.bonuses.length > 0) {
                            html = `<div class="d-flex align-items-center">
                                        <i class="far fa-folder"></i>
                                        <span class="ml-1">${item.designation} ${subcontent}</span>
                                    </div>`;
                        }


                        return $('<li>')
                            .append(html)
                            .appendTo(ul);
                    };
                },
                change: (e, item) => {
                    if(!item.item){
                        $(e.target).val("");
                        this.bonus = null
                    }
                },
                select: (e, item) => {
                    if (item.item) {
                        if (item.item.bonuses.length > 0) {
                            item.item.bonuses.forEach(bonus => {
                                this.addBonusRow(bonus)
                            })
                        } else {
                            this.addBonusRow(item.item)
                        }

                        $(e.target).val("")
                        this.bonus = null;
                    }
                },
                close: function(e, ui){
                    $("#bonusSearchInput").autocomplete("search", '');
                }
            }).focus((event, ui) => {
                $("#bonusSearchInput").autocomplete("search", '');
            });

            $("#userSearchInput").autocomplete({
                minLength: 0,
                source: (request, response) => {
                    $.ajax({
                        url : this.usersRoute,
                        type: 'get',
                        dataType : 'json',
                        headers: this.getHttpJsonRequestHeaders().headers,
                        data: { q: request.term, '!id': this.getCurrentSelectedUsersId().join(';'), 'under_contract' : this.canSelectAllUsers == 0 ? 1 : 0 },
                        success: (data) => {
                            response($.map(data, (item) => {
                                return Object.assign(item, {
                                    label: item.fullname,
                                    value: item.fullname
                                })
                            }))
                        }
                    });
                },
                change: (e, item) => {
                    if(!item.item){
                        $(e.target).val("");
                        this.user = null
                    }
                },
                select: (e, item) => {
                    if (item.item) {
                        this.addUserRow(item.item)
                        $(e.target).val("")
                        this.user = null
                    }
                }
            }).focus(() => {
                $("#userSearchInput").autocomplete("search", '');
            });

             $("#equipmentSearchInput").autocomplete({
                minLength: 0,
                source: (request, response) => {
                    $.ajax({
                        url : this.equipmentsRoute,
                        type: 'get',
                        dataType : 'json',
                        headers: this.getHttpJsonRequestHeaders().headers,
                        data: { q: request.term, '!id': this.getCurrentSelectedEquipmentId().join(';')},
                        success: (data) => {
                            response($.map(data, (item) => {
                                return Object.assign(item, {
                                    label: item.name,
                                    value: item.name
                                })
                            }))
                        }
                    });
                },
                change: (e, item) => {
                    if(!item.item){
                        $(e.target).val("");
                        this.equipment = null
                    }
                },
                select: (e, item) => {
                    if (item.item) {
                        this.addEquipmentRow(item.item)
                        $(e.target).val("")
                        this.equipment = null
                    }
                }
            }).focus(() => {
                $("#equipmentSearchInput").autocomplete("search", '');
            });

            $("#articleSearchInput").autocomplete({
                minLength: 0,
                source: (request, response) => {
                    $.ajax({
                        url : this.articlesRoute,
                        type: 'get',
                        dataType : 'json',
                        headers: this.getHttpJsonRequestHeaders().headers,
                        data: { q: request.term, '!id': this.getCurrentSelectedArticlesId().join(';')},
                        success: (data) => {
                            response($.map(data, (item) => {
                                return Object.assign(item, {
                                    label: item.name,
                                    value: item.name
                                })
                            }))
                        }
                    });
                },
                change: (e, item) => {
                    if(!item.item){
                        $(e.target).val("");
                        this.article = null
                    }
                },
                select: (e, item) => {
                    if (item.item) {
                        this.addArticleRow(item.item)
                        $(e.target).val("")
                        this.article = null
                    }
                }
            }).focus(() => {
                $("#articleSearchInput").autocomplete("search", '');
            });

            $("#dealsAutocomplete").autocomplete({
                minLength: 0,
                source: (request, response) => {
                    $.ajax({
                        url : this.dealsRoute,
                        type: 'get',
                        dataType : 'json',
                        headers: this.getHttpJsonRequestHeaders().headers,
                        data: {q: request.term},
                        success: (data) => {
                            response($.map(data, (item) => {
                                return Object.assign(item, {
                                    label: item.designation,
                                    value: item.designation,
                                    deal_designation: item.designation,
                                    deal_id: item.id
                                })
                            }))
                        }
                    });
                },
                change: (e, item) => {
                    if (!item.item) {
                        $(e.target).val("")
                        this.deal = null
                        this.checking.deal = null;
                    }
                },
                select: (e, item) => {
                    if(item.item){
                        this.checking.deal = item.item;
                        this.deal = item.item.designation;

                        if(this.checking.lot != null){
                            this.checking.lot = null;
                            this.lot = null;
                        }
                        if(this.checking.operations != null){
                            this.checking.operations = null;
                        }
                        this.checking.operation = null;
                    }          
                }
            }).focus(() => {
                $("#dealsAutocomplete").autocomplete("search", '');
            });

            $('#lotsAutocomplete').autocomplete({
                minLength: 0,
                source: (request, response) => {
                    $.ajax({
                        url: this.lotsRoute,
                        dataType : 'json',
                        headers: this.getHttpJsonRequestHeaders().headers,
                        data: {q: request.term , deal_id: this.checking.deal ? this.checking.deal.id : null},
                         success: (data) => {
                            response($.map(data, (item) => {
                                return Object.assign(item, {
                                    label: item.designation,
                                    value: item.designation,
                                    lot_designation: item.designation,
                                    lot_id: item.id,
                                });
                            }))
                        }
                    })
                },
                change: (e, item) => {
                    if (!item.item) {
                        $(e.target).val("")
                        this.lot = null;
                        this.checking.lot = null;
                        this.checking.operations = null;
                        this.checking.operation = null;
                    }
                },
                select: (e, item) => {
                    if(item.item){
                        this.checking.operations = item.item.operations;
                        this.checking.operation = null

                        if(this.checking.operations.length > 0){
                            this.checking.operation = this.checking.operations[0]
                        }

                        this.checking.lot = item.item;
                        this.lot = item.item.designation;

                        if(this.deal == null){
                            this.deal = item.item.deal.designation;
                            this.checking.deal = item.item.deal;
                        }
                    }
                }
            }).focus(() => {
                $('#lotsAutocomplete').autocomplete("search", '');
            })

            const jsonDataBackup = JSON.parse(this.oldData)
            var jsonData = null


          

            if (Array.isArray(jsonDataBackup)) {
                jsonData = JSON.parse(this.initialData)
            } else {
                jsonData = jsonDataBackup
            }

        

            this.day = jsonData.day
            this.description = jsonData.description

            if (jsonData.dates && Array.isArray(jsonData.dates)) {
                jsonData.dates.forEach((date) => {
                    this.addDate(date)
                })
            }

            if (jsonData.users && Array.isArray(jsonData.users)) {
                jsonData.users.forEach((user) => {
                    this.addUserRow(user)
                })
            }

            if(jsonData.equipments && Array.isArray(jsonData.equipments)) {
                jsonData.equipments.forEach((equipment) => {
                    this.addEquipmentRow(equipment)
                })
            }

           

            if (this.type == TYPE_CHECKING_HR && jsonData.objects && Array.isArray(jsonData.objects)) {
                jsonData.objects.forEach((object) => {
                    this.addObject(object);
                })
            }

            if(this.type == TYPE_CHECKING_GMAO && this.intervention){
                this.currentIntervention = JSON.parse(this.intervention);
                if(jsonData.objects && Array.isArray(jsonData.objects)){
                    jsonData.objects.forEach((object) => {
                        this.addObject(object);
                    })
                } else {
                    this.addObject();
                }
            }

            if(jsonData.articles && Array.isArray(jsonData.articles)) {
                jsonData.articles.forEach((article) => {
                    this.addArticleRow(article)
                })
            }

            if (jsonData.bonuses && Array.isArray(jsonData.bonuses)) {
                jsonData.bonuses.forEach((bonus) => {
                    this.addBonusRow(bonus)
                })
            }
        },
       
    }
</script>
